import * as Sentry from "@sentry/react";
import axios from "axios";
import { config } from "../constants";
import { getCookie } from "../lib";
import CommonError from "./CommonError";

const isLocal = process.env.NODE_ENV === "development";

const axiosClient = axios.create({
	baseURL: config.apiBaseUrl,
	timeout: 5000,
	headers: {
		"Content-Type": "application/json"
	}
});

// 요청 인터셉터
axiosClient.interceptors.request.use(
	(config) => {
		const token = getCookie("ACCESS_TOKEN");

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		return config;
	},
	(error) => Promise.reject(error)
);

// 응답 인터셉터
axiosClient.interceptors.response.use(
	(response) => {
		// !isLocal && console.log("[AXIOS RESPONSE] ", JSON.stringify(response, null, 2));
		return response.data;
	},
	(error) => {
		!isLocal && console.error("[AXIOS ERROR] Request: ", JSON.stringify(error.request, null, 2));
		!isLocal && console.error("[AXIOS ERROR] Response: ", JSON.stringify(error.response, null, 2));
		Sentry.captureException(error);

		if (error.response?.status === 401) {
			console.error("Unauthorized! Redirecting to login...");
			window.location.href = "/login";
		} else if (error.response?.status >= 400 && error.response?.status < 500 && error.response.data.status === "FAIL") {
			const responseData = error.response.data;
			return Promise.reject(
				new CommonError({ status: responseData.status, message: responseData.message, data: responseData.data })
			);
		} else if (error.response?.status === 500) {
			return Promise.reject(Error("SERVER_ERROR"));
		} else {
			return Promise.reject(Error("NETWORK_ERROR"));
		}
	}
);

export default axiosClient;
